import { useTranslations } from 'use-intl'

interface ShopHeaderProps {
  name: string
  originalName: string | null
  rating: number | null
  category: string
  priceLevel: string | null
}

export function ShopHeader({ name, originalName, rating, category, priceLevel }: ShopHeaderProps) {
  const t = useTranslations('shopDetail')

  return (
    <section className="w-full pb-8">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
        <div className="max-w-3xl">
          <div className="flex gap-3 mb-6">
            <span className="bg-surface-container-high text-on-surface px-3 py-1 rounded-md text-[0.75rem] font-bold tracking-[0.1em] uppercase">
              {category || 'Restaurant'}
            </span>
            {priceLevel !== null && (
              <span className="bg-surface-container-high text-on-surface px-3 py-1 rounded-md text-[0.75rem] font-bold tracking-[0.1em] uppercase">
                {priceLevel}
              </span>
            )}
          </div>
          
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-extrabold tracking-tight leading-snug mb-2 text-on-surface text-balance">
            {name}
          </h1>
          
          {originalName && (() => {
            // Normalize full-width/half-width characters for dedup comparison
            const normalize = (s: string) => s.replace(/[（）]/g, m => m === '（' ? '(' : ')').toLowerCase().trim()
            return !normalize(name).includes(normalize(originalName))
          })() && (
            <div className="flex items-center gap-3 mt-2">
              <span className="w-6 h-[1px] bg-primary/40 rounded-full flex-shrink-0"></span>
              <p className="ja-text text-sm md:text-base text-on-surface-variant/80 font-medium tracking-wide">
                {originalName}
              </p>
            </div>
          )}
        </div>
        
        <div className="md:text-right">
          <div className="bg-surface-container-lowest p-6 rounded-xl shadow-lg dark:shadow-none border border-outline-variant/20 dark:border-outline-variant/10">
            <p className="text-[0.75rem] text-on-surface-variant uppercase tracking-[0.1em] font-bold mb-1">
              {t('scoreBreakdown.title')}
            </p>
            <div className="text-[2rem] font-black text-primary leading-none">
              {rating ? rating.toFixed(2) : '-'}
              <span className="text-[1.25rem] text-on-surface-variant">/5</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
